/* eslint-disable no-console */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button } from 'antd';
import InputField from './form-helpers/InputField';
import LoadingSpinner from '../common/LoadingSpinner';
import { errorNotification } from '../../utils/notification-helpers';
import AuthService from '../../services/AuthService';

function LoginForm({ onSubmitBtnText }) {
  const { t } = useTranslation(['common']);
  const auth = new AuthService();

  const LoginSchema = useMemo(
    () =>
      Yup.object().shape({
        username: Yup.string().required(t('form.error.required')),
        password: Yup.string().required(t('form.error.required')),
      }),
    [t]
  );

  const initialValues = {
    username: '',
    password: '',
  };

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={LoginSchema}
        onSubmit={async (values) => {
          const userData = { ...values };
          return new Promise((resolve, reject) => {
            const { username, password } = userData;
            auth.login(username, password, (error) => {
              if (error) {
                errorNotification(t('form.error.wrongCredential'));
                reject();
              } else resolve();
            });
          });
        }}
      >
        {({ isSubmitting, isValid }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <InputField
                  type="text"
                  name="username"
                  label={t('form.label.emailAddress')}
                  placeholder={t('form.placeholder.emailAddress')}
                />
                <InputField
                  type="password"
                  name="password"
                  label={t('form.label.password')}
                  placeholder={t('form.placeholder.password')}
                />
                <Box paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    {isSubmitting ? <LoadingSpinner position="full" transparent={false} /> : onSubmitBtnText}
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

LoginForm.defaultProps = {
  onSubmitBtnText: 'Sign Up',
};

const { string } = PropTypes;

LoginForm.propTypes = {
  onSubmitBtnText: string,
};

export default LoginForm;
